// extracted by mini-css-extract-plugin
export const container = "basicPage-module--container--2GjJo";
export const containerGrid = "basicPage-module--containerGrid--1QHXU";
export const aboutContainer = "basicPage-module--aboutContainer--28neI";
export const section = "basicPage-module--section--38gtQ";
export const basicImg = "basicPage-module--basicImg--3uWkc";